// flashMessage.js
import { toast } from "react-toastify";

const FLASH_KEY = "flashMessage";

export const saveFlashMessage = (message, type = "info") => {
  console.log("💾 [Flash] Saving:", message, type);
  localStorage.setItem(
    FLASH_KEY,
    JSON.stringify({ message, type, ts: Date.now() })
  );
};

export const showFlashMessage = () => {
  const raw = localStorage.getItem(FLASH_KEY);
  if (!raw) {
    console.log("📦 [Flash] Loaded: null");
    return;
  }

  try {
    const { message, type } = JSON.parse(raw);
    console.log("📦 [Flash] Loaded:", { message, type });

    if (message) {
      // Delay ensures StrictMode unmount/mount doesn’t swallow the toast
      setTimeout(() => {
        if (type === "error") toast.error(message, {autoClose: 2000});
        else if (type === "success") toast.success(message, {autoClose: 2000});
        else toast.info(message,{autoClose: 2000});
      }, 0);
    }
  } catch (err) {
    console.error("❌ Flash parse error:", err);
  }

  localStorage.removeItem(FLASH_KEY);
};
